import React, {useEffect} from 'react';
import {useAppDispatch} from "../hooks/redux";
import {appSlice} from "../store/reducers/AppSlice";
import AccountsTable from "../components/accounts/AccountsTable";
import AccountTotalBalanceTableItem from "../components/accounts/AccountTotalBalanceTableItem";

const AccountsPage = () => {
    const dispatch = useAppDispatch();
    const {setTitle} = appSlice.actions;

    useEffect(() => {
        dispatch(setTitle('Accounts'));
    });

    return (
        <>
            <div className="relative w-full mx-auto max-w-7xl py-6 pl-8 pr-4">
                <AccountsTable/>
            </div>
            <div className="relative mx-auto py-6 pl-4 pr-8 min-w-[27%]">
                <table className="sticky top-20 min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                    <tr>
                        <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Totals
                        </th>
                        <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Balance
                        </th>
                    </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        <AccountTotalBalanceTableItem/>
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default AccountsPage;
